export default {
  playlist_count: {
    type: 'number',
    label: 'Playlist count',
  },
  playlist_stream_count_this_week_to_date: {
    type: 'number',
    label: 'This week to date',
  },
  playlist_stream_count_last_week_to_date: {
    type: 'number',
    label: 'Last week to date',
  },
  playlist_stream_wow_in_progress: {
    type: 'trend',
    label: 'Week over week to date',
  },
  skiprate_this_week_to_date: {
    type: 'percentage',
    label: 'Skiprate this week to date',
  },
  count_this_week_to_date: {
    type: 'number',
    label: 'This week to date',
  },
  count_last_week_to_date: {
    type: 'number',
    label: 'Last week to date',
  },
  wow_in_progress: {
    type: 'trend',
    label: 'Week over week to date',
  },
  count_last_week: {
    type: 'number',
    label: 'Last week',
  },
  count_last_last_week: {
    type: 'number',
    label: 'Last last week',
  },
  wow_last_completed: {
    type: 'trend',
    label: 'Week over week',
  },
  count_rtd: {
    type: 'number',
    label: 'Release to date',
  },
  totalChartCount: {
    type: 'number',
    label: 'Total charts',
  },
  totalChartStreams: {
    type: 'number',
    label: 'Total streams',
  },
  globalChartCount: {
    type: 'number',
    label: 'Total global charts',
  },
  globalStreamCount: {
    type: 'number',
    label: 'Total global streams',
  },
  localChartCount: {
    type: 'number',
    label: 'Total local charts',
  },
  localStreamCount: {
    type: 'number',
    label: 'Total local streams',
  },
  numberOfChartingTracks: {
    type: 'number',
    label: 'Total chart tracks',
  },
  numberOfChartingAlbums: {
    type: 'number',
    label: 'Total chart albums',
  },
  previousPosition: {
    type: 'position',
    label: 'Previous Position',
  },
  peakPosition: {
    type: 'position',
    label: 'Peak Position',
  },
  currentPosition: {
    type: 'position',
    label: 'Current Position',
  },
  countRtd: {
    type: 'number',
    label: 'Release to date',
  },
  countThisWeekToDate: {
    type: 'number',
    label: 'This week to date',
  },
  countLastWeekToDate: {
    type: 'number',
    label: 'Last full week',
  },
  wowInProgress: {
    type: 'trend',
    label: 'Week over week to date',
  },
  wowInProgressAbsolute: {
    type: 'change',
    label: 'Week over week to date',
  },
  wowLastCompleted: {
    type: 'trend',
    label: 'Week over week',
  },
  wowLastCompletedAbsolute: {
    type: 'change',
    label: 'Last full week',
  },
  pageUrl: {
    label: 'View profile page',
  },
  countLast4Weeks: {
    type: 'number',
    label: 'Last four weeks',
  },
  countLastLastWeek: {
    type: 'number',
    label: 'Last Last week',
  },
  countLastWeek: {
    type: 'number',
    label: 'Last full week',
  },
};
